var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-layout"},[_c('div',{staticClass:"login-container"},[_c('login')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-content"},[_c('img',{attrs:{"alt":"imagen principal","src":require("./../assets/img/img-login-content.png")}})])
}]

export { render, staticRenderFns }